import { getCasedHeadingTextBasedOnStyleOverrides } from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/util'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { PMPBodySectionItems } from './styledComponent'
import { getSectionListFormatConfig, renderSectionLabelList } from './sectionListFormat'

export default function PrintableComplaints({
  complaintsRef,
  debug,
  selectedComplaints,
  debugHighlightStates,
  styleOverrides,
  prescriptionViewSettings,
  listItemSeparator,
}) {
  const listCfg = getSectionListFormatConfig(styleOverrides, listItemSeparator)
  return (
    <PMPBodySectionItems
      ref={complaintsRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.complaints?.color}
      debugHighlight={debugHighlightStates?.complaints}
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Complaints',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
      >
        {renderSectionLabelList(selectedComplaints, listCfg)}
      </div>
    </PMPBodySectionItems>
  )
}
